// why is this a class
export class WorkspaceState {
    id = '';
    name = '';
}
